import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { Button, TextInput } from "../../../../../components";

const IndividualPhoneAuth = ({
  phoneNumber,
  setPhoneNumber,
  handlePhoneSubmit,
  loading,
  error,
  resetFieldError,
}) => {
  const rawPhone = phoneNumber ? String(phoneNumber).replace(/^\+91/, "").replace(/\D/g, "") : "";

  return (
    <form onSubmit={handlePhoneSubmit} className="w-full flex flex-col justify-start space-y-2.5" noValidate>
      <div className="form-group flex flex-col">
        <label
          htmlFor="phone"
          className="text-xs sm:text-sm font-bold text-gray-700 flex items-center gap-1.5"
          style={{ marginBottom: "0.2rem" }}
        >
          <FaWhatsapp className="text-[#25D366] w-4 h-4" />
          WhatsApp Number <span className="text-[#E5383B]"> * </span>
        </label>
        <div className="flex gap-2 items-stretch">
          <span className="bg-gray-100 border border-gray-200 text-gray-700 font-bold px-3 flex items-center rounded-lg text-sm select-none">
            +91
          </span>
          <div className="flex-grow">
            <TextInput
              type="tel"
              placeholderText="Enter 10-digit WhatsApp number"
              inputName="phone"
              inputValue={rawPhone}
              isRequired={true}
              error={null}
              inputClassName="!h-[44px] !rounded-xl !bg-white !border-gray-200 focus:!border-[#6366F1] !text-sm"
              handleChange={(e) => {
                const digits = e.target.value.replace(/^\+91/, "").replace(/\D/g, "");
                setPhoneNumber(digits);
                if (resetFieldError) resetFieldError("phone");
              }}
            />
          </div>
        </div>
        {error?.phone && <div className="text-xs text-[#f00] mt-1 pl-[52px] text-left">{error.phone}</div>}
      </div>

      <div className="flex flex-col gap-2 pt-0">
        <div className="w-full">
          <Button
            version="secondary"
            text="Send OTP"
            type="submit"
            loading={loading}
            width="100%"
            className="w-full justify-center font-extrabold"
          />
        </div>
      </div>
    </form>
  );
};

export default IndividualPhoneAuth;
